import apiRTKQ from 'src/apiRTKQ'

const apiInvoices = apiRTKQ.injectEndpoints({
  endpoints: builder => ({
    fetchBuyerInvoice: builder.query({
      query: id => `/buyer/invoices/${id}`,
      providesTags: ['Invoices'],
    }),
    fetchBuyerInvoices: builder.query({
      query: () => '/buyer/invoices/',
      providesTags: ['Invoices'],
    }),
    fetchBuyerLineItems: builder.query({
      query: params => ({
        url: '/buyer/line-items/',
        params,
      }),
      providesTags: ['LineItems'],
    }),
    approveInvoice: builder.mutation({
      query: ({ id }) => ({
        url: `/buyer/invoices/${id}/mark_approved/`,
        method: 'POST',
      }),
      invalidatesTags: ['Invoices'],
    }),
    unapproveInvoice: builder.mutation({
      query: ({ id }) => ({
        url: `/buyer/invoices/${id}/remove_approval/`,
        method: 'POST',
      }),
      invalidatesTags: ['Invoices'],
    }),
    disputeInvoice: builder.mutation({
      query: params => ({
        url: `/buyer/invoices/${params.id}/mark_disputed/`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Invoices'],
    }),
    undisputeInvoice: builder.mutation({
      query: ({ id }) => ({
        url: `/buyer/invoices/${id}/remove_dispute/`,
        method: 'POST',
      }),
      invalidatesTags: ['Invoices'],
    }),
    approveInvoiceAfterDispute: builder.mutation({
      query: ({ id }) => ({
        url: `/buyer/invoices/${id}/mark_approved_after_dispute/`,
        method: 'POST',
      }),
      invalidatesTags: ['Invoices'],
    }),
    markInvoicePaid: builder.mutation({
      query: ({ id }) => ({
        url: `/buyer/invoices/${id}/mark_paid/`,
        method: 'POST',
      }),
      invalidatesTags: ['Invoices'],
    }),
  }),
})

export const {
  useFetchBuyerInvoiceQuery,
  useFetchBuyerInvoicesQuery,
  useFetchBuyerLineItemsQuery,
  useApproveInvoiceMutation,
  useUnapproveInvoiceMutation,
  useDisputeInvoiceMutation,
  useUndisputeInvoiceMutation,
  useApproveInvoiceAfterDisputeMutation,
  useMarkInvoicePaidMutation,
} = apiInvoices

export default apiInvoices
